export interface AuthLogin {
  username: string;
  password: string;
}
